import { render, staticRenderFns } from "./winning.vue?vue&type=template&id=131c7571&scoped=true"
import script from "./winning.vue?vue&type=script&lang=js"
export * from "./winning.vue?vue&type=script&lang=js"
import style0 from "./winning.vue?vue&type=style&index=0&id=131c7571&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131c7571",
  null
  
)

export default component.exports